import React from "react";
import { useTranslation } from "react-i18next";

const TableLabels = () => {
  const [_] = useTranslation("global");
  const role = localStorage.getItem("role");

  const roles_labels = {
    employee: [
      _("panel.date"),
      _("panel.user"),
      _("panel.fulfillmentprofit"),
      _("panel.confirmation_price"),
      _("panel.cancellationprofit"),
      _("panel.post_delivery_charge"),
      _("panel.fulfillmentpricing"),
      _("panel.edit"),
    ],
    admin: [
      _("panel.date"),
      _("panel.user"),
      _("panel.fulfillmentprofit"),
      _("panel.confirmation_price"),
      _("panel.cancellationprofit"),
      _("panel.post_delivery_charge"),
      _("panel.fulfillmentpricing"),
      _("panel.edit"),
    ],
  };

  return (
    <tr>
      {roles_labels[role].map((label) => {
        return <th>{label}</th>;
      })}
    </tr>
  );
};

export default TableLabels;
